


























import {Component, Vue} from 'vue-property-decorator';
import {Can} from '@casl/vue';
import {
  SelectionListFilterModel,
  SelectionListGroupingModel,
} from '@/components/controls/selectionList/interfaces';
import {pmoduleTypeFilter} from '@/components/nodeComponent/filters';
import {pmoduleGroupings} from '@/components/nodeComponent/groupings';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {getAllModules} from '@/store/modules/entities/pmodules/pmoduleWithMeasurementsModule';
import Loading from '@c/controls/Loading.vue';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import BrokerLogs from '@/components/BrokerLogs.vue';

@Component({
  components: {
    Can,
    Loading,
    SelectionList,
    BrokerLogs,
  },
})
export default class AdministrationBrokerLogs extends Vue {
  // Фильтр программных модулей по типу
  pmoduleTypeFilter: SelectionListFilterModel = pmoduleTypeFilter;

  // Список группировок программных модулей
  pmoduleGroupings: SelectionListGroupingModel[] = pmoduleGroupings;

  // Список программных модулей
  pmodules: PModuleWithMeasurements[] = [];

  // Список выбранных идентификаторов программных модулей
  selectedPModuleIds: string[] = [];

  // Загрузка программных модулей
  pmodulesLoading = true;
  pmodulesError = false;
  async loadPModules() {
    try {
      this.pmodulesLoading = true;
      this.pmodulesError = false;
      const pmodules = await getAllModules(); //TODO: refactor, use store
      this.pmodules = [...pmodules];
      this.selectedPModuleIds = this.pmodules.map((x: any) => x.guid);
    } catch {
      this.pmodulesError = true;
    } finally {
      this.pmodulesLoading = false;
    }
  }

  async created() {
    await this.loadPModules();
  }
}
